import moment from "moment";
import { fn_change_step, fn_end_order_change_step } from "./FnBodyStep";
import {
  aesDecoding,
  aesEncoding,
  analyticeEvent,
  baeminMobileOrderFg,
  ygyMobileOrderFg,
  posOrderTab,
  posOrdermMbileOrderFg,
  frontLog,
} from "../utils/Utils";
import { reload_order_list_all } from "../http/OrderConn";
import { fn_removeOrderNew, fn_closeDetailView } from "./FnBodyDetail";
import { select_access_token } from "../http/TokenConn";
import { tpay_cancel } from "../http/dlvTpayConn";
import { api_notify_reload } from "../http/OrderConn";
import { fn_return_success, fn_return_fail } from "http/SettingConn";
import { fn_show_setting } from "function/FnBodySetting";
import { fn_layerCstYgytimeList } from "function/FnBodyLayer";
import { fn_prevPage } from "../function/FnBodyOrder";
import { MobileOrderFg } from "types";

/**
 * 포스 브릿지 통신용
 * @param rootStore
 */

// OKGO 리로드 요청
export function fn_bridge_reload(rootStore) {
  let ret = posBridge(rootStore, '{"command" : "RELOAD"}', "reload");
  if (!ret || ret !== "success") {
    //rootStore.layerStore.setLayerAlertType("fail");
    //rootStore.layerStore.setLayerAlertView(true);
  }
  return ret;
}

//
export function fn_bridge_pdf_popup(rootStore) {
  let ret = posBridge(
    rootStore,
    '{"command" : "PDF_POPUP", "link" : "https://okgo.okpos.co.kr/OKPOS_배달주문중개_사용자 매뉴얼(배포용)_V2.0_20220719_compressed.pdf"}',
    "POPUP"
  );
  return ret;
}

// 헬프유 열기
export function fn_bridge_helpu_popup(rootStore) {
  analyticeEvent("cs", "csRemote Button", rootStore.searchStore.getShopCd); //GA4
  let ret = posBridge(rootStore, '{"command" : "HELPU_POPUP", "link" : "https://helpu.kr/ndgp/"}', "POPUP");
  return ret;
}

// 주방출력 사용해보기 열기
export function fn_bridge_payfree_popup(rootStore, link, btn) {
  analyticeEvent("mkt", btn, rootStore.searchStore.getShopCd); //GA4
  let ret = posBridge(rootStore, '{"command" : "URL_POPUP", "link" :"' + link + '" }', "POPUP");
  return ret;
}

//네이버 설정 열기
export function fn_bridge_naver_popup(rootStore) {
  let naverPop;
  let encodeShopCd;
  const settingStore = rootStore.settingStore;
  const searchStore = rootStore.searchStore;
  encodeShopCd = btoa(searchStore.getShopCd);

  if (settingStore.getActive === "dev") {
    naverPop = "https://tdum.okpos.co.kr/asp/naver_pop/pop?popShopCd=" + encodeShopCd;
  } else if (settingStore.getActive === "staging") {
    naverPop = "https://dum.okpos.co.kr:8443/asp/naver_pop/pop?popShopCd=" + encodeShopCd;
  } else if (settingStore.getActive === "real") {
    naverPop = "https://dum.okpos.co.kr:8443/asp/naver_pop/pop?popShopCd=" + encodeShopCd;
  }

  let ret = posBridge(rootStore, '{"command" : "NAVER_POPUP", "link" : "' + naverPop + '"}', "POPUP");
  return ret;
}

export function fn_bridge_print_confirm(rootStore) {
  let ret;

  try {
    ret = posBridge(rootStore, '{"command" : "PRINT_CONFIRM"}', "print_confirm");
  } catch (e) {
    ret = null;
  }
  return ret;
}

// 프린터 관련 셋팅
export function fn_bridge_shopinfo_set(rootStore) {
  let ret;
  try {
    ret = posBridge(
      rootStore,
      '{"command" : "SHOP_SETTING", "initView":"' +
        rootStore.settingStore.getInitView +
        '","viewType":"' +
        rootStore.settingStore.getOrderViewType +
        '","viewOrder":"' +
        rootStore.settingStore.getOrderViewOrder +
        '","deliveryDfTime":"' +
        rootStore.settingStore.getDeliveryDfTime +
        '","cookingDfTime":"' +
        rootStore.settingStore.getCookingDfTime +
        '","pickupDfTime":"' +
        rootStore.settingStore.getPickupDfTime +
        '","autoAcceptFlag":"' +
        rootStore.settingStore.getAutoAcceptFlag +
        '", "printerSetting" : ' +
        JSON.stringify(rootStore.settingStore.getPrinterInfo) +
        ' ,"soundSetting" : ' +
        JSON.stringify(rootStore.settingStore.getSoundPlayInfo) +
        ' ,"managerSetting" : ' +
        JSON.stringify(rootStore.settingStore.getManagerSetting) +
        ',"etcPrintSettings" : ' +
        JSON.stringify(rootStore.settingStore.getEtcPrinterInfo) +
        ',"progressingExposeFlag":"' +
        rootStore.settingStore.getProgressingExposeFlag +
        '"}',
      "printset"
    );
  } catch (e) {
    ret = null;
  }

  return ret;
}

// 동기화관련 셋팅
export async function fn_bridge_shopinfo_change_set(rootStore) {
  let ret = posBridge(
    rootStore,
    '{"command" : "SHOP_SETTING_CHANGE", "initView":"' +
      rootStore.settingStore.getInitView +
      '","viewType":"' +
      rootStore.settingStore.getOrderViewType +
      '","viewOrder":"' +
      rootStore.settingStore.getOrderViewOrder +
      '","deliveryDfTime":"' +
      rootStore.settingStore.getDeliveryDfTime +
      '","cookingDfTime":"' +
      rootStore.settingStore.getCookingDfTime +
      '","pickupDfTime":"' +
      rootStore.settingStore.getPickupDfTime +
      '", "printerSetting" : ' +
      JSON.stringify(rootStore.settingStore.getPrinterInfo) +
      ' ,"soundSetting" : ' +
      JSON.stringify(rootStore.settingStore.getSoundPlayInfo) +
      ' ,"managerSetting" : ' +
      JSON.stringify(rootStore.settingStore.getManagerSetting) +
      ',"etcPrintSettings" : ' +
      JSON.stringify(rootStore.settingStore.getEtcPrinterInfo) +
      ',"progressingExposeFlag":"' +
      rootStore.settingStore.getProgressingExposeFlag +
      '"}',
    "printset"
  );
  if (ret) {
    try {
    } catch (e) {
      ret = "change_set_err";
    }
  }
  return ret;
}

// 프린터 관련 셋팅
export function fn_bridge_quickaddr_set(rootStore) {
  let ret;
  try {
    let ret = posBridge(rootStore, '{"command" : "NEW_ADD_ADDR"}', "close");
  } catch (e) {
    ret = null;
  }
  return ret;
}

// 프린터 관련 셋팅
export function fn_bridge_print_action(rootStore, command, param, rate, printerCode) {
  let ret = posBridge(
    rootStore,
    '{"command" : "' +
      command +
      '", "usePrintNo" : "' +
      param +
      '", "baudRate" : "' +
      rate +
      '", "printerCode" : "' +
      printerCode +
      '"}',
    "printaction"
  );
  return ret;
}

// 덤 포탈 닫기
export function fn_bridge_close(rootStore) {
  let ret = posBridge(rootStore, '{"command" : "CLOSE_POW"}', "close");
  if (!ret || ret !== "success") {
  }
  return ret;
}

// notify 닫기
export function fn_notify_close(rootStore, type) {
  let ret = posBridge(rootStore, '{"command" : "CLOSE_NOTIFY_POPUP"}', "close");
  let result = JSON.parse(ret);

  if (!result.resultCode || result.resultCode !== "success") {
  } else {
    api_notify_reload(rootStore);
  }

  if (type != "baemin" && type != "panda" && !posOrderTab(rootStore)) {
    reload_order_list_all(rootStore);
  }

  return ret;
}

export function fn_bridge_re_close(rootStore) {
  let ret = posBridge(rootStore, '{"command" : "CLOSE_POW_RE"}', "close");

  if (!ret || ret !== "success") {
  }
  return ret;
}

// 포스 사운드 여부
export function fn_bridge_sound(rootStore, level) {
  let ret = posBridge(rootStore, '{"command" : "SOUND", "level" : "' + level + '"}', "sound_level");
  let obj = JSON.parse(ret);
  if (!obj || obj.resultCode !== "success") {
    rootStore.layerStore.setLayerAlertType("fail");
    rootStore.layerStore.setLayerAlertView(true);
  }
  return ret;
}

export function fn_bridge_log(rootStore, type) {
  analyticeEvent("cs", "csLogSend Button", rootStore.searchStore.getShopCd); //GA4
  let ret = posBridge(rootStore, '{"command" : "LOG_SEND"}');
  let obj = JSON.parse(ret);

  if (!type) {
    fn_show_setting(rootStore, false);
    rootStore.layerStore.setLayerAlertType("log_send_confirm");
    rootStore.layerStore.setLayerAlertView(true);
  }

  return ret;
}

// 주문서 출력
export function fn_bridge_print(rootStore, type) {
  if (type === null || type === "" || type === "null" || type === undefined) {
    rootStore.layerStore.setLayerAlertType("reprint_type_null");
    rootStore.layerStore.setLayerAlertView(true);
    return;
  }

  rootStore.layerStore.setLayerReprint(false);
  let viewStore = rootStore.viewStore.getOrderDetail;

  let ret;
  if (type === "1") {
    ret = posBridge(
      rootStore,
      '{"command" : "PRINT_KITCHEN", "mobileOrderNo" : "' + viewStore.mobileOrderNo + '"}',
      "print"
    );
    let obj = JSON.parse(ret);

    if (!obj || obj.resultCode !== "success") {
      rootStore.layerStore.setLayerAlertType("fail");
      rootStore.layerStore.setLayerAlertView(true);
    }
  } else if (type === "2") {
    ret = posBridge(
      rootStore,
      '{"command" : "PRINT_ORDER", "mobileOrderNo" : "' + viewStore.mobileOrderNo + '"}',
      "print"
    );
    let obj = JSON.parse(ret);

    if (!obj || obj.resultCode !== "success") {
      rootStore.layerStore.setLayerAlertType("fail");
      rootStore.layerStore.setLayerAlertView(true);
    }
  } else if (type === "3") {
    //후킹주문 재출력 버튼 추가
    ret = posBridge(
      rootStore,
      '{"command" : "NOT_KITCHEN_PRINT", "mobileOrderNo" : "' + viewStore.mobileOrderNo + '"}',
      "print"
    );
    let obj = JSON.parse(ret);

    if (!obj || obj.resultCode !== "success") {
      rootStore.layerStore.setLayerAlertType("fail");
      rootStore.layerStore.setLayerAlertView(true);
    }
  } else if (type === "4") {
    ret = posBridge(
      rootStore,
      '{"command" : "HOOKING_PRINT_ORDER", "mobileOrderNo" : "' + viewStore.mobileOrderNo + '"}',
      "print"
    );
    let obj = JSON.parse(ret);

    if (!obj || obj.resultCode !== "success") {
      rootStore.layerStore.setLayerAlertType("fail");
      rootStore.layerStore.setLayerAlertView(true);
    }
  } else if (type === "5") {
    //API 주방출력 (영수+주방)
    ret = posBridge(
      rootStore,
      '{"command" : "API_ORDER_PRINT", "mobileOrderNo" : "' +
        viewStore.mobileOrderNo +
        '", "orderNo" : "' +
        viewStore.orderNo +
        '", "saleDate" : "' +
        viewStore.saleDate +
        '", "printType" : "all"}',
      "print"
    );
    let obj = JSON.parse(ret);

    if (!obj || obj.resultCode !== "success") {
      rootStore.layerStore.setLayerAlertType("fail");
      rootStore.layerStore.setLayerAlertView(true);
    }
  } else if (type === "6") {
    //시간대별 매출 간편인쇄
    let startVal = rootStore.salesStore.getSalesDateVal.start_val
      ? rootStore.salesStore.getSalesDateVal.start_val
      : new Date();
    let endVal = rootStore.salesStore.getSalesDateVal.start_val
      ? rootStore.salesStore.getSalesDateVal.end_val
      : new Date();

    ret = posBridge(
      rootStore,
      '{"command" : "TIME_SALES_PRINT", "startDate" : "' +
        moment(startVal, "YYYYMMDDHHmmss").format("YYYYMMDD") +
        '", "endDate" : "' +
        moment(endVal, "YYYYMMDDHHmmss").format("YYYYMMDD") +
        '"}',
      "print"
    );
    let obj = JSON.parse(ret);

    if (!obj || obj.resultCode !== "success") {
      rootStore.layerStore.setLayerAlertType("fail");
      rootStore.layerStore.setLayerAlertView(true);
    }
  } else if (type === "7") {
    //API 주방출력 (영수)
    ret = posBridge(
      rootStore,
      '{"command" : "API_ORDER_PRINT", "mobileOrderNo" : "' +
        viewStore.mobileOrderNo +
        '", "orderNo" : "' +
        viewStore.orderNo +
        '", "saleDate" : "' +
        viewStore.saleDate +
        '", "printType" : "receipt"}',
      "print"
    );
    let obj = JSON.parse(ret);

    if (!obj || obj.resultCode !== "success") {
      rootStore.layerStore.setLayerAlertType("fail");
      rootStore.layerStore.setLayerAlertView(true);
    }
  } else if (type === "8") {
    //API 주방출력 (주방)
    ret = posBridge(
      rootStore,
      '{"command" : "API_ORDER_PRINT", "mobileOrderNo" : "' +
        viewStore.mobileOrderNo +
        '", "orderNo" : "' +
        viewStore.orderNo +
        '", "saleDate" : "' +
        viewStore.saleDate +
        '", "printType" : "kitchen"}',
      "print"
    );
    let obj = JSON.parse(ret);

    if (!obj || obj.resultCode !== "success") {
      rootStore.layerStore.setLayerAlertType("fail");
      rootStore.layerStore.setLayerAlertView(true);
    }
  } else if (type === "0") {
    ret = posBridge(
      rootStore,
      '{"command" : "PRINT_ORDER", "mobileOrderNo" : "' + viewStore.mobileOrderNo + '"}',
      "print"
    );
    let obj = JSON.parse(ret);

    if (!obj || obj.resultCode !== "success") {
      rootStore.layerStore.setLayerAlertType("fail");
      rootStore.layerStore.setLayerAlertView(true);
    } else {
      ret = posBridge(
        rootStore,
        '{"command" : "PRINT_KITCHEN", "mobileOrderNo" : "' + viewStore.mobileOrderNo + '"}',
        "print"
      );
      obj = JSON.parse(ret);

      if (!obj || obj.resultCode !== "success") {
        rootStore.layerStore.setLayerAlertType("fail");
        rootStore.layerStore.setLayerAlertView(true);
      }
    }
  }
  return ret;
}

// 주문 취소
export function fn_bridge_order_cancel(rootStore, type) {
  let viewStore = rootStore.viewStore.getOrderDetail;
  let shopCd = rootStore.searchStore.getShopCd;
  let cidPickUpCheck = true;

  cidPickUpCheck = viewStore.mobileOrderFg == "23" && viewStore.payType === "PAID" ? false : true;

  const payload = {
    command: "AUTO_REFUND",
    shopCd: shopCd,
    saleDate: viewStore.saleDate,
    orderNo: viewStore.orderNo,
    mobile_order_no: viewStore.mobileOrderNo,
    mobileOrderFg: viewStore.mobileOrderFg,
  };

  let ret = posBridge(rootStore, JSON.stringify(payload), "cancel");
  let obj = JSON.parse(ret);

  if (obj.resultMsg == "영수증 관리 창으로 이동합니다") {
    fn_closeDetailView(rootStore);
  }

  if (cidPickUpCheck) {
    const isSuccess = ret && (obj.resultCode === "success" || obj.resultCode === "already_success");

    if (isSuccess) {
      if (type === "end" && obj.resultCode === "success") {
        fn_end_order_change_step(rootStore, "900");
      } else {
        fn_change_step(rootStore, "900");
      }
    } else {
      rootStore.layerStore.setFailErrMsg(obj.resultMsg);
      rootStore.layerStore.setLayerAlertType("failMsg");
      rootStore.layerStore.setLayerAlertView(true);
    }
  }

  return ret;
}

// 포스 신규 주문 수락 처리
export function fn_bridge_order_accept(rootStore, mobileOrderNo, min, orderNo) {
  let tempMin = 0;
  rootStore.layerStore.setChangeCstTime(min);
  try {
    tempMin = parseInt(min);
  } catch (e) {
    tempMin = 0;
  }

  if (
    rootStore.viewStore.getOrderDetail.mobileOrderFg != "27" &&
    rootStore.viewStore.getOrderDetail.morderTypeCd != "P" &&
    rootStore.viewStore.getOrderDetail.isInputCookingTime
  ) {
    if (tempMin <= 0 || tempMin > 120) {
      rootStore.layerStore.setLayerAlertType("expectTimeError");
      rootStore.layerStore.setLayerAlertView(true);
      return;
    }
  }

  let ret = posBridge(
    rootStore,
    '{"command" : "ACCEPT", "mobileOrderNo" : "' +
      mobileOrderNo +
      '", "min" : "' +
      min +
      '", "orderNo" : "' +
      orderNo +
      '", "mobileOrderFg" : "' +
      rootStore.viewStore.getOrderDetail.mobileOrderFg +
      '", "morderTypeCd" : "' +
      rootStore.viewStore.getOrderDetail.morderTypeCd +
      '", "stepCd" : "", "isPolling" : "false"}',
    "order"
  );
  if (ret) {
    let obj = JSON.parse(ret);
    if (obj.resultCode === "success") {
      //주문 처리 완료. 주문 list reload 처리
      reload_order_list_all(rootStore);
      rootStore.viewStore.setDetailClose();
      rootStore.layerStore.setLayerCstExpectTime(false);
      rootStore.layerStore.setLayerCstExpectTimeYgy(false);
    } else {
      if (obj.resultMsg == "" || obj.resultMsg == undefined) {
        rootStore.layerStore.setLayerAlertType("fail");
        rootStore.layerStore.setLayerAlertView(true);
      } else {
        rootStore.layerStore.setAlertCustomMessage(obj.resultMsg);
        rootStore.layerStore.setLayerAlertType("fail");
        rootStore.layerStore.setLayerAlertView(true);
      }
    }
  } else {
    rootStore.layerStore.setLayerAlertType("fail");
    rootStore.layerStore.setLayerAlertView(true);
  }
  return ret;
}

// 포스 신규 주문 알람
export function fn_bridge_new_order_notify(rootStore, data) {
  fn_log_error("", "notify", JSON.stringify(data));

  if (data.prodCardView.length > 80) {
    data.prodCardView = data.prodCardView.substr(0, 80);
  }
  //todo = 요기요연동된 매장,값 true일경우 조리시간 넣기
  if (ygyMobileOrderFg(data.mobileOrderFg)) {
    fn_layerCstYgytimeList(rootStore, data);
  }

  let dataEncoding = btoa(aesEncoding(JSON.stringify(data))); //todo
  let partnerType = data.partnerType;

  if (data.mobileOrderFg == "27") {
    if (data.morderTypeCd == "D") {
      partnerType = "YGYDLV";
    } else if (data.morderTypeCd == "P") {
      partnerType = "YGYPICK";
    } else {
      partnerType = "YGYSHOP";
    }
  }
  if (data.mobileOrderFg == "31") {
    partnerType = "YGYEXPRESS";
  }

  if (data.mobileOrderFg == "28") {
    if (data.morderTypeCd == "P") {
      partnerType = "BAEMINPICK";
    } else if (data.morderTypeCd == "O") {
      partnerType = "BAEMINSHOP";
    }
  }

  if (data.mobileOrderFg == "32") {
    partnerType = "PANDAEXPRESS";
  }

  if (data.mobileOrderFg == "33") {
    if (data.morderTypeCd == "D") {
      partnerType = "PANDADLV";
    } else {
      partnerType = "PANDAPICK";
    }
  }

  if (data.mobileOrderFg == "35") {
    if (data.morderTypeCd == "D") {
      partnerType = "DDANGYODLV";
    } else if (data.morderTypeCd == "P") {
      partnerType = "DDANGYOPICK";
    } else {
      partnerType = "DDANGYOSHOP";
    }
  }

  if (data.mobileOrderFg == "40") {
    if (data.morderTypeCd == "D") {
      partnerType = "MUKKEBIDLV";
    } else if (data.morderTypeCd == "P") {
      partnerType = "MUKKEBIPICK";
    }
  }

  if (data.mobileOrderFg === "44") {
    partnerType = "OLTTEAAH";
  }

  if (data.mobileOrderFg === "48") {
    partnerType = "NAVER";
  }

  if (data.mobileOrderFg === "51") {
    partnerType = "NAVERCONNECT";
  }

  if (data.mobileOrderFg === "52") {
    partnerType = "DDANGBAEDAL";
  }

  if (data.mobileOrderFg === "55") {
    partnerType = "HASAMDONG";
  }

  const payload = {
    command: "NOTIFY",
    mobileOrderNo: data.mobileOrderNo,
    partnerType: partnerType,
    data: dataEncoding,
  };

  let ret = posBridge(rootStore, JSON.stringify(payload), "alert");

  if (ret) {
    let obj = JSON.parse(ret);
    if (obj.resultCode === "success") {
    } else {
      rootStore.layerStore.setLayerAlertType("fail");
      rootStore.layerStore.setLayerAlertView(true);
    }
  } else {
    rootStore.layerStore.setLayerAlertType("fail");
    rootStore.layerStore.setLayerAlertView(true);
  }

  if (posOrderTab(rootStore)) {
    rootStore.settingStore.setKioskOrderState("all");
  }

  return ret;
}

// 포스 주문 토스트 알람
export function fn_bridge_state_notify(rootStore, data, notifyText) {
  let orderRow;
  let tempKey;
  tempKey = data.mobileOrderNoView;
  if (tempKey == null || tempKey == "" || posOrdermMbileOrderFg(data.mobileOrderFg)) {
    tempKey = data.orderNo;
  }

  if (!(data.type === "HOOKING_ORDER_NEW" || data.type === "CID_ORDER_NEW")) {
    const orderList = rootStore.orderStore.getOrderList;
    orderList.map(row => {
      if (row.mobileOrderNo === data.mobileOrderNo) orderRow = row;
    });

    if (orderRow == null || orderRow == "") orderRow = data;

    if (typeof data.orderNo !== "undefined" && data.orderNo.length <= 4) {
      orderRow = { ...orderRow, mobileOrderNoView: tempKey };
    } else {
      orderRow = { ...data, mobileOrderNoView: tempKey };
    }
  } else {
    orderRow = { ...data, mobileOrderNoView: tempKey };
  }

  //위메프오 토스트알림 포스주문번호
  if (
    orderRow.partnerType === "WMPO" ||
    orderRow.partnerType === "SPECIALDELIVERY" ||
    orderRow.partnerType === "YOGIYO" ||
    orderRow.partnerType === "YOGIYOEXPRESS"
  ) {
    //orderRow = { ...data, mobileOrderNoView: data.orderNo }
    orderRow.mobileOrderNoView = data.orderNo;
  }

  if (baeminMobileOrderFg(orderRow.mobileOrderFg)) {
    orderRow = { ...data, mobileOrderNoView: data.mobileOrderNo.slice(-4) };
  }

  if (orderRow.partnerType === "YOGIYO" && orderRow.morderTypeCd === "P") {
    orderRow = { ...data, mobileOrderNoView: data.orderNo.slice(-6) };
  }

  let ret;

  if (data.mobileOrderFg === MobileOrderFg.KIOSK) {
    if (data.type === "CID_ORDER_NEW") {
      if (data.morderTypeCd === "O") {
        rootStore.settingStore.setPosNotifySound("kioskShopAlarm");
      } else {
        rootStore.settingStore.setPosNotifySound("kioskPickAlarm");
      }
    } else {
      rootStore.settingStore.setPosNotifySound("default");
    }
  }

  if (data.mobileOrderFg === MobileOrderFg.POS_PREPAID) {
    rootStore.settingStore.setPosNotifySound("posOrderAlarm");
  }
  if (data.mobileOrderFg === MobileOrderFg.QR_ORDER) {
    rootStore.settingStore.setPosNotifySound("qrOrderAlarm");
  }
  if (data.mobileOrderFg === MobileOrderFg.TABLE_ORDER) {
    rootStore.settingStore.setPosNotifySound("tableOrderAlarm");
  }

  if (data.type === "allCompletedOrder") {
    ret = posBridge(rootStore, '{"command" : "TEXTNOTIFY",  "orderTypeView" : "ORDER_ALL_COMPLETE"}', "alert");
  } else {
    ret = posBridge(
      rootStore,
      '{"command" : "TEXTNOTIFY", "mobileOrderNo" : "' +
        data.mobileOrderNo +
        '", "TEXT" : "' +
        notifyText +
        '","mobileOrderNoView" : "' +
        orderRow.mobileOrderNoView +
        '", "orderTypeView" : "' +
        orderRow.orderTypeView +
        '", "orderState" : "' +
        rootStore.settingStore.getPosNotifySound +
        '"}',
      "alert"
    );
  }

  if (ret) {
    let obj = JSON.parse(ret);

    if (obj.resultCode === "success") {
    } else {
      rootStore.layerStore.setLayerAlertType("fail");
      rootStore.layerStore.setLayerAlertView(true);
    }
  } else {
    rootStore.layerStore.setLayerAlertType("fail");
    rootStore.layerStore.setLayerAlertView(true);
  }
  return ret;
}

// 포스 신규 주문 알람창 주문 상세 화면
export function fn_bridge_order_detail(rootStore, mobileOrderNo) {
  let ret = posBridge(rootStore, '{"command" : "ORDER_VIEW", "mobileOrderNo" : "' + mobileOrderNo + '"}', "order");
  if (ret) {
    let obj = JSON.parse(ret);
    if (obj.resultCode === "success") {
    } else {
      rootStore.layerStore.setLayerAlertType("fail");
      rootStore.layerStore.setLayerAlertView(true);
    }
  } else {
    rootStore.layerStore.setLayerAlertType("fail");
    rootStore.layerStore.setLayerAlertView(true);
  }
  return ret;
}

// 포스 신규 주문 알람창 주문 제어
export function fn_bridge_order_state(rootStore, mobileOrderNo, min, orderNo, state, mobileOrderFg, morderTypeCd) {
  let ret;
  if (state) {
    ret = posBridge(
      rootStore,
      '{"command" : "ACCEPT", "mobileOrderNo" : "' +
        mobileOrderNo +
        '", "min" : "' +
        min +
        '", "orderNo" : "' +
        orderNo +
        '", "mobileOrderFg" : "' +
        mobileOrderFg +
        '", "morderTypeCd" : "' +
        morderTypeCd +
        '", "stepCd" : "", "isPolling" : "false"}',
      "order"
    );
  } else {
    ret = posBridge(
      rootStore,
      '{"command" : "REFUND", "mobileOrderNo" : "' + mobileOrderNo + '", "orderNo" : "' + orderNo + '"}',
      "order"
    );
  }
  if (ret) {
    let obj = JSON.parse(ret);
    if (obj.resultCode === "success") {
      //주문 처리 완료. 주문 list reload 처리
    } else {
      rootStore.layerStore.setLayerAlertType("fail");
      rootStore.layerStore.setLayerAlertView(true);
    }
  } else {
    rootStore.layerStore.setLayerAlertType("fail");
    rootStore.layerStore.setLayerAlertView(true);
  }
  return ret;
}

// pos로 선택한 주소 전달
export function fn_send_address_pos(rootStore, addAdress) {
  rootStore.addressSearchStore.setDetailSearchAddrDetail(addAdress);

  let addressValue = rootStore.addressSearchStore.getSelectRoadAddrVal
    ? rootStore.addressSearchStore.getSelectAddrVal
    : rootStore.addressSearchStore.getClickedPosAddress;

  let roadAddressValue = rootStore.addressSearchStore.getSelectRoadAddrVal || "";

  let ret = posBridge(
    rootStore,
    '{"command" : "ADDRESS_SEARCH", ' +
      '"address" : "' +
      addressValue +
      '" ,"road_address" : "' +
      roadAddressValue +
      '" ,"address_detail" : "' +
      rootStore.addressSearchStore.getDetailSearchAddrDetail +
      '"}',
    "address"
  );
  if (ret) {
    let obj = JSON.parse(ret);
    if (obj.resultCode === "success") {
    }
  } else {
  }
  return ret;
}

// 포스 주문 수정 요청(CID)
export function fn_bridge_order_change(rootStore, type) {
  if (rootStore.settingStore.getPosType != "0" && rootStore.settingStore.getPosType != "2" && type == "P") {
    rootStore.layerStore.setLayerAlertType("order_pos");
    rootStore.layerStore.setLayerAlertView(true);
  } else {
    let btn = "";
    if (type === "M") {
      btn = "orderCidEdit Button";
    } else if (type === "P") {
      btn = "orderCidPayment Button";
    }
    analyticeEvent("orderCid", btn, rootStore.searchStore.getShopCd); //GA4

    let order = rootStore.viewStore.getOrderDetail;
    let cmdType = type === "M" ? "ORDER_CHANGE" : "ORDER_PAY_REQUEST";

    let ret = posBridge(
      rootStore,
      '{"command" : "' +
        cmdType +
        '", "mobileOrderNo" : "' +
        order.mobileOrderNo +
        '", "saleDate" : "' +
        order.saleDate +
        '", "orderNo":"' +
        order.orderNo +
        '"}',
      "order"
    );
    if (ret) {
      let obj = JSON.parse(ret);
      if (obj.resultCode === "success") {
        rootStore.viewStore.setDetailClose();
      } else {
        rootStore.layerStore.setLayerAlertType("fail");
        rootStore.layerStore.setLayerAlertView(true);
      }
    } else {
      rootStore.layerStore.setLayerAlertType("fail");
      rootStore.layerStore.setLayerAlertView(true);
    }
    return ret;
  }
}

// 포스 주문 결제 요청(CID)
export function fn_bridge_order_payment(rootStore) {
  let order = rootStore.viewStore.getOrderDetail;
  let ret = posBridge(
    rootStore,
    '{"command" : "ORDER_PAYMENT", "mobileOrderNo" : "' +
      order.mobileOrderNo +
      '", "saleDate" : "' +
      order.saleDate +
      '", "orderNo":"' +
      order.orderNo +
      '"}',
    "order"
  );
  if (ret) {
    let obj = JSON.parse(ret);
    if (obj.resultCode === "success") {
      rootStore.layerStore.setLayerOrderPaymentAlertView(false);
    } else {
      rootStore.layerStore.setLayerAlertType("fail");
      rootStore.layerStore.setLayerAlertView(true);
    }
  } else {
    rootStore.layerStore.setLayerAlertType("fail");
    rootStore.layerStore.setLayerAlertView(true);
  }
  return ret;
}

export function posBridge(rootStore, param, type) {
  try {
    if (typeof CallBackEvent !== "undefined" && CallBackEvent.onCallback) {
      return CallBackEvent.onCallback(param);
    } else {
      console.warn("CallBackEvent is not defined");
      return null;
    }
  } catch (err) {
    rootStore.layerStore.setAlertCustomTitle(type === "load" ? "LOAD 처리 실패" : "처리 실패");
    rootStore.layerStore.setAlertCustomMessage(err);
    rootStore.layerStore.setLayerAlertType("alert_custom");
    rootStore.layerStore.setLayerAlertView(true);
    return err;
  }
}

// 매장기본 정보 조회
export async function fn_bridge_load_shop(rootStore) {
  let ret = posBridge(rootStore, '{"command" : "LOAD_SHOP"}', "load");
  if (ret) {
    try {
      let obj = JSON.parse(ret);
      let storeCode;
      if (obj.command === "LOAD_SHOP") {
        if (process.env.REACT_APP_ENV !== "local") {
          storeCode = aesDecoding(obj.shopCd);
        } else {
          storeCode = "DT0257";
        }
        if (obj.etcPrintSettings == undefined || obj.etcPrintSettings == null) {
          obj.etcPrintSettings = {
            defaultPrintSettings: [],
            addPrintSettings: [],
          };
        }

        let setStSessionDatas = {
          ...obj,
          user_name: storeCode + obj.connPosNo,
          shopCd: storeCode,
          soundSetting: obj.soundSetting,
          printerSetting: obj.printerSetting,
          managerSetting: obj.managerSetting,
          etcPrintSettings: obj.etcPrintSettings,
        };

        rootStore.searchStore.setStSession(setStSessionDatas);

        fn_log_error(rootStore, "LOAD_SHOP_DATA", JSON.stringify(obj));

        localStorage.setItem("env", "");
        localStorage.setItem("env", process.env.REACT_APP_ENV);
        localStorage.setItem("shopCd", "");
        localStorage.setItem("shopCd", storeCode);
        localStorage.setItem("connPosNo", obj.connPosNo);

        fn_saleDate_setting(rootStore, obj);

        if (obj == null || obj == undefined || obj == "") {
          ret = "FAIL";
          frontLog(rootStore, "ERROR", "fn_bridge_load_shop(rootStore)", "load_shop obj null");
        } else {
          ret = "OK";
        }
      }
    } catch (e) {
      ret = "load_err";
    }
    // 토큰으로 매장코드 조회
  }
  return ret;
}

export function fn_bridge_delivery_order_cancel_check(rootStore) {
  select_access_token(rootStore).then(res => {
    fn_removeOrderNew(rootStore, rootStore.viewStore.getOrderDetail.mobileOrderNo);

    if (rootStore.viewStore.getOrderDetail.dlvTargetCd === "TPAY") {
      tpay_cancel(rootStore, rootStore.viewStore.getOrderDetail.mobileOrderNo);
    } else {
      rootStore.layerStore.setLayerAlertType("dlv_not_call");
      rootStore.layerStore.setLayerAlertView(true);
    }
  });
}

export function fn_bridge_order_all_complete(rootStore, check) {
  rootStore.layerStore.setLayerLoadingView(true);
  let ret = null;
  let lastOrderList = [];
  let shopCd = rootStore.searchStore.getShopCd;
  let saleDate = rootStore.searchStore.getSaleDate;

  lastOrderList = check
    ? [...rootStore.layerStore.getAllCompletedPaidList]
    : [...rootStore.layerStore.getAllCompletedPaidList, ...rootStore.layerStore.getAllCompletedNoPaidList];

  let data =
    '{ "command" : "ORDER_ALL_COMPLETE", "shopCd" : "' +
    shopCd +
    '", "saleDate" : "' +
    saleDate +
    '", "orderList" : ' +
    JSON.stringify(lastOrderList) +
    "}";

  if (lastOrderList.length <= 0) {
    rootStore.layerStore.setLayerLoadingView(false);
  }

  try {
    ret = posBridge(rootStore, data, "ORDER_ALL_COMPLETE");
  } catch (e) {
    ret = null;
  }
  rootStore.layerStore.setAllCompletedPaidList([]);
  rootStore.layerStore.setAllCompletedNoPaidList([]);
  rootStore.viewStore.setAllCompleteBaeminList(false);
  return ret;
}

// 미리 듣기 재생
export function fn_bridge_sound_play(rootStore, data) {
  const { settingStore, layerStore } = rootStore;

  if (settingStore.getSoundPlayInfo.soundLevel === "0") {
    layerStore.setLayerAlertType("sound_lever_zero");
    layerStore.setLayerAlertView(true);
    return;
  }

  const payload = {
    command: "PLAY_ALARM",
    alarm: data,
  };

  try {
    const posBridgeResponse = posBridge(rootStore, JSON.stringify(payload));

    if (posBridgeResponse) {
      const obj = JSON.parse(posBridgeResponse);
      if (obj.resultCode === "success") return;
    }
  } catch (error) {
    console.error("fn_bridge_sound_play error", error);
  }
}

// 로그 출력
export function fn_log_error(rootStore, command, data) {
  const payload = {
    command,
    message: data,
  };

  posBridge(rootStore, JSON.stringify(payload));
}

// 사이트 바로 가기
export function fn_bridge_agency_popup(rootStore, type) {
  const { OutAgencyUrl, OutAgencyVideoUrl } = rootStore.settingStore;
  const bmpcliteUrl = "https://delivery.okpos.co.kr/bmpclitedownload.html";

  const apiUrlMap = {
    baemin: OutAgencyUrl.baeminApi,
    ygy: OutAgencyUrl.ygyApi,
    naver: OutAgencyUrl.naverApi,
    panda: OutAgencyUrl.pandaApi,
    ygyEntry: OutAgencyVideoUrl.ygyEntryApi,
    wmpo: OutAgencyVideoUrl.wmpoApi,
    ddangyo: OutAgencyVideoUrl.ddangyoApi,
    muk: OutAgencyVideoUrl.mukApi,
    baeminDown: bmpcliteUrl,
    bmEntry: OutAgencyVideoUrl.bmEntryApi,
    oltteaah: OutAgencyUrl.oltteaahApi,
    naverBooking: OutAgencyUrl.naverBookingApi,
  };
  const apiUrl = apiUrlMap[type];
  if (!apiUrl) return;

  const payload = {
    command: "NAVER_POPUP",
    link: apiUrl,
  };

  return posBridge(rootStore, JSON.stringify(payload), "POPUP");
}

//배달앱 연동 설정 사용법 영상보기
export function fn_bridge_agency_video(rootStore, type) {
  let apiUrl;
  const OutAgencyVideoUrl = rootStore.settingStore.OutAgencyVideoUrl;
  if (type === "baemin") {
    apiUrl = OutAgencyVideoUrl.baeminApi;
  } else if (type === "ygy") {
    analyticeEvent("setting", "settingYogiyoOperationManual", rootStore.searchStore.getShopCd);
    apiUrl = OutAgencyVideoUrl.ygyApi;
  } else if (type === "ygySet") {
    analyticeEvent("setting", "settingYogiyoSettingManual", rootStore.searchStore.getShopCd);
    apiUrl = OutAgencyVideoUrl.ygySetApi;
  } else if (type === "naverBooking") {
    apiUrl = OutAgencyVideoUrl.naverBookingApi;
  } else {
    apiUrl = OutAgencyVideoUrl.default;
  }

  const payload = {
    command: "NAVER_POPUP",
    link: apiUrl,
  };

  try {
    posBridge(rootStore, JSON.stringify(payload), "POPUP");
  } catch (error) {
    console.error("fn_bridge_agency_video error", error);
  }
}

// 고급, 기본 연동 사용법 영상보기
export function fn_bridge_connect_video(rootStore, type) {
  let apiUrl;
  if (type == "basic") {
    analyticeEvent("setting", "settingHookingOperationManual", rootStore.searchStore.getShopCd);
    apiUrl = rootStore.settingStore.OutAgencyConnectUrl.basic;
  } else {
    apiUrl = rootStore.settingStore.OutAgencyConnectUrl.advanced;
  }

  let ret = posBridge(rootStore, '{"command" : "NAVER_POPUP", "link" : "' + apiUrl + '"}', "POPUP");
  return ret;
}

export function fn_saleDate_setting(rootStore, obj) {
  if (rootStore.hasOwnProperty("salesStore")) {
    //영업일기준 매출날짜 셋팅
    let yyyyMMdd = String(obj.saleDate);
    let sYear = yyyyMMdd.substring(0, 4);
    let sMonth = yyyyMMdd.substring(4, 6);
    let sDateEnd = yyyyMMdd.substring(6, 9);

    let saleDateFormat = new Date(Number(sYear), Number(sMonth) - 1, Number(sDateEnd));

    rootStore.salesStore.setSalesDateTermVal("today", saleDateFormat);
    rootStore.salesStore.setSalesDateTermVal("week", new Date(Date.parse(saleDateFormat) - 6 * 1000 * 60 * 60 * 24));
    rootStore.salesStore.setSalesDateTermVal(
      "yesterday",
      new Date(Date.parse(saleDateFormat) - 1 * 1000 * 60 * 60 * 24)
    );
    rootStore.salesStore.setSalesDateTermVal(
      "lastmonth",
      new Date(saleDateFormat.getFullYear(), saleDateFormat.getMonth() - 1, 1)
    );
    rootStore.salesStore.setSalesDateTermVal(
      "month",
      new Date(saleDateFormat.getFullYear(), saleDateFormat.getMonth(), 1)
    );
  }
}

// 배민 신규주문 상세보기
export function fn_bridge_new_order_notify_baemin(rootStore, data) {
  let ret = posBridge(rootStore, '{"command" : "BMAGENT_NOTIFY_POP",  "orderNo" : "' + data.mobileOrderNo + '" }');
  if (ret) {
    let obj = JSON.parse(ret);
    if (obj.resultCode === "success") {
      fn_notify_close(rootStore);
    } else if (obj.resultCode === "fail") {
    } else {
      //배민 실패 응답코드 처리
    }
  } else {
  }
  return ret;
}

// 배민 주문 상세보기
export function fn_bridge_order_detail_baemin(rootStore, data) {
  let ret = posBridge(rootStore, '{"command" : "BMAGENT_DETAIL_POP",  "orderNo" : "' + data.mobileOrderNo + '" }');
  if (ret) {
    let obj = JSON.parse(ret);
    if (obj.resultCode === "success") {
      rootStore.viewStore.setDetailBaeminView(true);
    } else if (obj.resultCode === "fail") {
    } else {
      //배민 실패 응답코드 처리
      if ((400 < obj.code && obj.code < 500) || !rootStore.settingStore.getBaeminStatus.login) {
        rootStore.layerStore.setLayerAlertType("baemin_status_off");
        rootStore.layerStore.setLayerAlertView(true);
      } else {
        rootStore.settingStore.setBaeminUseStatus("baeminStatus", "E");
      }
    }
  } else {
  }
  return ret;
}

// 배민 주문 상태값 변경
export function fn_bridge_order_status_baemin(rootStore, data, status) {
  let ret = posBridge(
    rootStore,
    '{"command" : "BMAGENT_DELIVERY_STATUS",  "orderNo" : "' +
      data.mobileOrderNo +
      '", "deliveryStatus" : "' +
      status +
      '", "riderId" : ""}'
  );
  if (ret) {
    let obj = JSON.parse(ret);
    if (obj.resultCode === "success") {
      fn_closeDetailView(rootStore);
    } else if (obj.resultCode === "fail") {
    } else {
      //배민 실패 응답코드 처리
      if ((400 < obj.code && obj.code < 500) || !rootStore.settingStore.getBaeminStatus.login) {
        rootStore.layerStore.setLayerAlertType("baemin_status_off");
        rootStore.layerStore.setLayerAlertView(true);
      } else {
        rootStore.settingStore.setBaeminUseStatus("baeminStatus", "E");
      }
    }
  } else {
  }
  return ret;
}

// 배민OFF -> 배민 로그인창
export function fn_bridge_baemin_agency_login(rootStore) {
  let ret = posBridge(rootStore, '{"command" : "BMAGENT_LOGIN"}');
  if (ret) {
    let obj = JSON.parse(ret);
    if (obj.resultCode === "success") {
    } else if (obj.resultCode === "notExists") {
      rootStore.layerStore.setLayerAlertType("baemin_disConnect");
      rootStore.layerStore.setLayerAlertView(true);
    } else {
    }
  } else {
  }
  return ret;
}

// 배민연동 x 배민 주문 상세보기
export function fn_bridge_new_detail_notify_baemin(rootStore, data) {
  let ret = posBridge(rootStore, '{"command" : "BMAGENT_NOTIFY_DETAIL",  "orderNo" : "' + data + '" }');
  if (ret) {
    let obj = JSON.parse(ret);
    if (obj.resultCode === "success") {
      fn_notify_close(rootStore);
    } else if (obj.resultCode === "fail") {
    }
  } else {
  }
  return ret;
}

// 배달의민족 설치하기
export function fn_baemin_install(rootStore) {
  fn_bridge_agency_popup(rootStore, "baeminDown");
}

// 테스트 주문 넣기
export function fn_test_order(rootStore) {
  let ret = posBridge(rootStore, '{"command" : "TEST_ORDER"}');
  if (!ret || ret !== "success") {
  }
  return ret;
}

// 수락후 pos만 접수보내기
export function fn_bridge_order_accept_pos(rootStore, item) {
  let data =
    '{"command" : "ACCEPT", "mobileOrderNo" : "' +
    item.mobileOrderNo +
    '", "min" : "", "orderNo" : "' +
    item.orderNo +
    '", "mobileOrderFg" : "' +
    item.mobileOrderFg +
    '", "morderTypeCd" : "' +
    item.morderTypeCd +
    '", "stepCd" : "' +
    item.stepCd +
    '", "isPolling" : "' +
    item.isPolling +
    '"}';
  let ret = posBridge(rootStore, data, "order");
  return ret;
}

// 완료후 주문 취소 pos만 취소보내기
export function fn_bridge_order_cancel_pos(rootStore, item, type) {
  let shopCd = rootStore.searchStore.getShopCd;
  let data =
    '{ "command" : "AUTO_REFUND", "shopCd" : "' +
    shopCd +
    '", "saleDate" : "' +
    item.saleDate +
    '", "orderNo" : "' +
    item.orderNo +
    '", "mobile_order_no" : "' +
    item.mobileOrderNo +
    '", "mobileOrderFg" : "' +
    item.mobileOrderFg +
    '" }';
  let ret = posBridge(rootStore, data, "cancel");
  if (ret) {
    let obj = JSON.parse(ret);

    rootStore.layerStore.setLayerPartialCancelType("mobileOrderNo", item.mobileOrderNo);

    if (obj.resultCode === "success") {
      if (type == "return") {
        if (item.pendingState == "PARTIAL_CANCEL") {
          rootStore.layerStore.setLayerPartialCancelType("type", "first");
          rootStore.layerStore.setLayerPartialCancelView(true);
        } else {
          rootStore.layerStore.setLayerAlertType("return_success");
          rootStore.layerStore.setLayerAlertView(true);
        }
        fn_return_success(rootStore, rootStore.settingStore.getReturnFailOn.pendingNo);
      }
    } else if (obj.resultCode === "already_success") {
      if (item.pendingState == "PARTIAL_CANCEL") {
        rootStore.layerStore.setLayerPartialCancelType("type", "already");
        rootStore.layerStore.setLayerPartialCancelView(true);
      } else {
        rootStore.layerStore.setLayerAlertType("return_already");
        rootStore.layerStore.setLayerAlertView(true);
      }
      fn_return_success(rootStore, rootStore.settingStore.getReturnFailOn.pendingNo);
    } else {
      if (type == "return") {
        rootStore.layerStore.setLayerAlertType("return_fail");
        rootStore.layerStore.setLayerAlertView(true);
      }
    }
    fn_return_fail(rootStore);
  }
  return ret;
}

// 동기화 notify 보내기
export function fn_bridge_synchronize(rootStore) {
  let data = '{"command" : "TEXTNOTIFY",  "orderTypeView" : "SYNCHRONIZE"}';
  let ret = posBridge(rootStore, data, "alert");
  if (ret) {
    let obj = JSON.parse(ret);
    if (obj.resultCode === "success") {
      api_notify_reload(rootStore);
    }
  }
  return ret;
}

// 영수증 설정 테스트 출력
export function fn_bridge_receipt_test(rootStore) {
  let ret = posBridge(
    rootStore,
    '{"command" : "API_TEST_PRINT", "mobileOrderNo" : "", "orderNo" : "", "printType" : "' +
      rootStore.layerStore.getPrintOutType +
      '"}',
    "print"
  );
  if (ret) {
    let obj = JSON.parse(ret);
    if (obj.resultCode === "success") {
    } else {
    }
  }
  return ret;
}

// front에서 직접 notif보내기
export function fn_bridge_text_notify(rootStore, notifyText, type, flag) {
  if (flag !== "배달") {
    rootStore.settingStore.setPosNotifySound("default");
  }

  let data =
    '{"command" : "TEXTNOTIFY", "mobileOrderNo" : "", "TEXT" : "' +
    notifyText +
    '","mobileOrderNoView" : "' +
    type +
    '", "orderTypeView" : "' +
    flag +
    '", "orderState" : "' +
    rootStore.settingStore.getPosNotifySound +
    '"}';
  let ret = posBridge(rootStore, data, "alert");
  if (ret) {
    let obj = JSON.parse(ret);
    if (obj.resultCode === "success") {
      //api_notify_reload(rootStore);
    }
  }
  return ret;
}

// 매출 임의 등록
export function fn_bridge_sales_registration(rootStore) {
  rootStore.settingStore.setPosNotifySound("default");
  let data = '{"command" : "SALES_REGISTRATION"}';
  let ret = posBridge(rootStore, data, "alert");
  if (ret) {
    let obj = JSON.parse(ret);
    if (obj.resultCode === "success") {
      //api_notify_reload(rootStore);
    } else {
      fn_log_error(rootStore, "SALES_REGISTRATION", "실패");
    }
  }
  return ret;
}

// 매장주문보기(pos/kiosk)
export function fn_bridge_pos_order_list(rootStore) {
  let ret = posBridge(
    rootStore,
    '{"command" : "POS_ORDER_LIST", "orderType" : "pos", "orderEndYn" : "' +
      rootStore.settingStore.getManagerSetting?.orderEnd +
      '", "viewType" : "' +
      rootStore.settingStore.getOrderViewType +
      '", "viewOrder" : "' +
      rootStore.settingStore.getOrderViewOrder +
      '", "pageNo" : ' +
      rootStore.orderStore.getPagingInfo.page_no +
      "}"
  );
  if (ret) {
    let obj = JSON.parse(ret);
    if (obj.resultCode === "000") {
      const data = obj.data;
      if (data) {
        rootStore.orderStore.addOrderListAll(rootStore.rabbitMqStore.getRabbitAllNew, data.list);
        rootStore.orderStore.setPagingInfo("max_page", Number(data.maxPage));
        rootStore.orderStore.setPagingInfo("end_max_page", Number(data.maxPage));
        rootStore.endOrderStore.setEndOrderCompleteList(data.list);

        if (data.list.length > 0) {
          // 하단 알림 문구 layer 제거
          rootStore.searchStore.setOrderSearchNoDataView(false);
        } else {
          if (rootStore.orderStore.getPagingInfo.page_no > 1) {
            fn_prevPage(rootStore);
          }
          if (rootStore.searchStore.getSearchNoDataVal === "SEARCH") {
            rootStore.searchStore.setOrderSearchNoDataView(true);
          }
          rootStore.searchStore.setSearchNoDataVal("NO_DATA");
        }
      }
    } else {
    }
  }
  return ret;
}

//  pos/kiosk주문 완료 상태변경 POS_ORDER_SALE
export function fn_bridge_pos_order_sale(rootStore, order) {
  let ret = posBridge(
    rootStore,
    '{"command" : "POS_ORDER_SALE", "orderNo" : "' +
      order.orderNo +
      '", "mobileOrderFg" : "' +
      order.mobileOrderFg +
      '", "mobileOrderNo" : "' +
      order.mobileOrderNo +
      '", "morderTypeCd" : "' +
      order.morderTypeCd +
      '"}'
  );
  if (ret) {
    let obj = JSON.parse(ret);
    if (obj.resultCode === "success") {
      //fn_bridge_pos_order_reload(rootStore)
      rootStore.layerStore.setLayerOrderComplete(false);
    } else {
    }
  }
  return ret;
}

//  pos/kiosk주문 호출, 재호출 상태변경 POS_ORDER_CALL
export function fn_bridge_pos_order_call(rootStore, order, type, call) {
  const callType = type === "send" ? "AlarmTalkSend" : call;
  rootStore.viewStore.setOrderDetail(rootStore.orderStore.getOrderList, order.mobileOrderNo);

  const payload = {
    command: "POS_ORDER_CALL",
    orderNo: order.orderNo,
    mobileOrderFg: order.mobileOrderFg,
    mobileOrderNo: order.mobileOrderNo,
    morderTypeCd: order.morderTypeCd,
    callType: callType,
    bellNo: order.bellNo || order.deliverNo,
  };

  // 브릿지 커맨드
  const posBridgeResponse = posBridge(rootStore, JSON.stringify(payload));

  if (!posBridgeResponse) {
    console.error("포스 브릿지 호출 실패", payload);
    return;
  }

  try {
    const response = JSON.parse(posBridgeResponse);
    if (response.resultCode === "success") {
      return;
    } else if (response.resultCode === "Check") {
      rootStore.layerStore.setAlarmCallMsg("msg", response.resultMsg);
      rootStore.layerStore.setLayerAlertType("call_type_send");
      rootStore.layerStore.setLayerAlertView(true);
    } else {
      const failMessage = `${callType === "PagerBell" ? "진동벨" : "알림톡"} 호출에 실패했습니다.`;
      rootStore.layerStore.setAlarmCallMsg("failMsg", failMessage);
      rootStore.layerStore.setAlarmCallMsg("code", response.resultCode);
      rootStore.layerStore.setAlarmCallMsg("msg", response.resultMsg);
      rootStore.layerStore.setLayerAlertType("call_type_send_fail");
      rootStore.layerStore.setLayerAlertView(true);
    }
  } catch (error) {
    console.log("error", error);
    console.log("포스 브릿지 호출 실패", posBridgeResponse);
  }
}

//  pos/kiosk주문 조리중 상태변경 POS_ORDER_COOK
export function fn_bridge_pos_order_cook(rootStore, order) {
  const payload = {
    command: "POS_ORDER_COOK",
    orderNo: order.orderNo,
    mobileOrderFg: order.mobileOrderFg,
    mobileOrderNo: order.mobileOrderNo,
    morderTypeCd: order.morderTypeCd,
  };

  let posBridgeResponse = posBridge(rootStore, JSON.stringify(payload));

  try {
    const response = JSON.parse(posBridgeResponse);
    if (!response || response.resultCode !== "success") {
      console.log("포스 브릿지 호출 실패", posBridgeResponse);
      return;
    }
  } catch (error) {
    console.log("포스 브릿지 호출 실패", error);
  }
  return posBridgeResponse;
}

//  pos/kiosk주문 reload
export function fn_bridge_pos_order_reload(rootStore) {
  fn_bridge_pos_order_list(rootStore);
  rootStore.viewStore.setDetailClose();
}

//  미완료메뉴보기 list
export function fn_bridge_incomplete_menu(rootStore) {
  rootStore.viewStore.setIncompleteMenuNewTime(
    rootStore.timerStore.currentTime?.toLocaleDateString() +
      " " +
      rootStore.timerStore.currentTime?.toLocaleTimeString()
  );
  let ret = posBridge(rootStore, '{"command" : "POS_ORDER_INCOMPLETE_LIST"}');
  if (ret) {
    let obj = JSON.parse(ret);
    if (obj.resultCode === "000") {
      const data = obj.data;
      if (data) {
        rootStore.menuStore.setIncompleteMenuList(data.list);
        rootStore.menuStore.setIncompleteMenuCnt(data.maxNum);
      }
    } else {
    }
  }
  return ret;
}

// 네이버 로그인 화면에서 배달매니저 이동 버튼 호출
export function fn_bridge_naver_login_exit(rootStore, status) {
  const payload = {
    command: "PROC_NAVER_LOGIN",
    status: status,
  };
  let ret = posBridge(rootStore, JSON.stringify(payload));
  try {
    const response = JSON.parse(ret);
    if (response.resultCode === "success") {
      return;
    }
  } catch (error) {
    console.log("포스 브릿지 호출 실패", error);
  }
  return ret;
}